import { format, parseISO } from 'date-fns';
import { format as formatTz, utcToZonedTime } from 'date-fns-tz';
import moment from 'moment';

const curr = new Date();

export function getCurrYear() {
  return curr.getFullYear();
}

export function getCurrMonth() {
  return curr.getMonth() + 1;
}

export function getCurrDate() {
  return curr.getDate();
}

export function getCurrFullDate() {
  return `${curr.getFullYear()}. ${curr.getMonth() + 1}. ${curr.getDate()}`;
}

export const monthList = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

export const dayList = Array.from({ length: 31 }, (v, i) => i + 1);

export const getCurrDateString = () => {
  return moment().format('YYYYMMDD');
};

export const getYMFromRange = (range) => {
  const now = new Date();
  let targetDate = new Date(now);

  if (range === '1Y') {
    targetDate.setFullYear(now.getFullYear() - 1);
  } else if (range === '6M') {
    targetDate.setMonth(now.getMonth() - 6);
  } else if (range === '3M') {
    targetDate.setMonth(now.getMonth() - 3);
  }

  const year = targetDate.getFullYear();
  const month = targetDate.getMonth() + 1; // 0~11이므로 +1

  // yyyymm 형식으로 리턴 (예: '202401')
  return `${year}${month.toString().padStart(2, '0')}`;
};

/** function for timezone **/
function getZonedDate(tz = 'America/New_York') {
  const now = new Date();
  return utcToZonedTime(now, tz);
}

export function getCurrYearZoneTime(tz) {
  const zoned = getZonedDate(tz);
  return zoned.getFullYear();
}

export function getCurrMonthZoneTime(tz) {
  const zoned = getZonedDate(tz);
  return zoned.getMonth() + 1;
}

export function getCurrDateZoneTime(tz) {
  const zoned = getZonedDate(tz);
  return zoned.getDate();
}

export function getCurrFullDateZoneTime(tz) {
  const zoned = getZonedDate(tz);
  return `${zoned.getFullYear()}. ${zoned.getMonth() + 1}. ${zoned.getDate()}`;
}

export function getFormattedCurrTimeByTimezone(tz, fmt) {
  const zoned = getZonedDate(tz);
  return formatTz(zoned, fmt, { timeZone: tz });
}

export function formatZonedDate(isoDate, timeZone, dateFormat = 'yyyy-MM-dd HH:mm:ss') {
  if (!isoDate) return '';
  try {
    const date = parseISO(isoDate);
    const zoned = utcToZonedTime(date, timeZone);
    return format(zoned, dateFormat, { timeZone });
  } catch (err) {
    console.log(err);
    return '';
  }
}

export function formatZonedTime(date, timeZone, dateFormat = 'yyyy-MM-dd HH:mm:ss') {
  const zoned = utcToZonedTime(date, timeZone);
  return format(zoned, dateFormat, { timeZone });
}
